import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";


export default function NeuroSharp() {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="big-title">NeuroSharp</div>

        <img
          src="/projects/neurosharp.webp"
          alt="NeuroSharp"
          className="project-image"
        />

        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("neuroSharpDescriptionShort")}
          </p>

          <p className="section-content-unbounded">
            {t("neuroSharpLinkLabel")}{" "}
            <a
              href="https://neurosharp.com.uy"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              {t("neuroSharpLinkText")}↗
            </a>
          </p>
          <p className="section-content-unbounded">
            {t("neuroSharpDescriptionLong")}
          </p>
        </div>
        <div className="store-badges-container">
          <a
            href="https://play.google.com/store/apps/details?id=com.vallejoyuridamian.neurosharp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/badges/google-play-badge.png"
              alt="Get it on Google Play"
              className="store-badge"
            />
          </a>
          <a
            href="https://apps.apple.com/uy/app/neurosharp/id6749867627"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/badges/app-store-badge.svg"
              alt="Download on the App Store"
              className="store-badge"
            />
          </a>
        </div>        
        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("neurosharpPage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>        
        <Footer /> 
      </div>
    </div>
  );
}
